<style src="./ItemDetail.scss" lang="scss" scoped></style>
<template>
  <section class="item-detail">
    <div class="item-info">
      <div class="item-id">
        <span class="badge-small badge-danger" v-if="itemQuote.strictToME">
          ME
        </span>
        <span class="badge-small badge-info" v-if="itemQuote.lot">LOTE {{ itemQuote.lot }}</span>
        <span class="badge-small badge-info">ITEM {{ itemQuote.number }}</span>
      </div>

      <button type="button"
        class="badge-small badge-warning btn-revision"
        v-shortkey="['ctrl', 'm']"
        @shortkey="buttonMessage"
        @click="buttonMessage">
          {{ revisionStatus }}
      </button>
    </div>

    <div class="item-description">
      <div class="item-description-container" v-show="!editMode.description.isEditing">
        <div class="text-area" @click.right.stop.prevent="enterEditMode('description')">
          <span
            v-for="(wordItem, wordIdx) in wordSeparated"
            :key="wordIdx"
            :class="{ 'clickable-word': wordItem.length > 2 }"
            @click="selectWord(wordItem)">
            {{ wordItem }}
          </span>
        </div>
      </div>

      <div class="item-description-container" v-if="editMode.description.isEditing">
        <span class="text-edit--title">Descrição</span>
        <div class="edit-fieldset edit-description" >
          <textarea
            class="textbox-edit textbox-input"
            v-model="editMode.description.text"
            v-shortkey="{ confirmEdit: ['enter'], cancelEdit: ['esc'] }" @shortkey="editAction"
            v-click-outside="closeEditMode">
          </textarea>
        </div>
      </div>
    </div>

    <div class="item-specs">
      <div class="spec-unity">
        <span class="badge-small badge-default" v-show="!editMode.quantity.isEditing" @click.right.stop.prevent="enterEditMode('quantity')">
          {{ itemQuote.quantity | DecimalNumber }}
        </span>
        <div class="edit-fieldset edit-specs" v-if="editMode.quantity.isEditing">
          <span class="text-edit--title">Quantidade</span>
          <input
            class="textbox-edit textbox-input"
            v-model="editMode.quantity.text"
            v-shortkey="{ confirmEdit: ['enter'], cancelEdit: ['esc'] }" @shortkey="editAction"
            v-click-outside="closeEditMode">
        </div>

        <span class="badge-small badge-default" v-show="!editMode.unity.isEditing" @click.right.stop.prevent="enterEditMode('unity')">
          {{ itemQuote.unity }}
        </span>
        <div class="edit-fieldset edit-specs" v-if="editMode.unity.isEditing">
          <span class="text-edit--title">Unidade</span>
          <input
            class="textbox-edit textbox-input"
            v-model="editMode.unity.text"
            v-shortkey="{ confirmEdit: ['enter'], cancelEdit: ['esc'] }" @shortkey="editAction"
            v-click-outside="closeEditMode">
        </div>

        <span
          class="badge-small badge-default"
          v-show="!editMode.factor.isEditing"
          @click.right.stop.prevent="enterEditMode('factor')">
          x {{ itemQuote.factor }}
        </span>
        <div class="edit-fieldset edit-specs" v-if="editMode.factor.isEditing">
          <span class="text-edit--title">Fator</span>
          <input
            class="textbox-edit textbox-input"
            v-model="editMode.factor.text"
            v-shortkey="{ confirmEdit: ['enter'], cancelEdit: ['esc'] }" @shortkey="editAction"
            v-click-outside="closeEditMode">
        </div>

      </div>
      <div class="spec-values">
        <span
          class="badge-small badge-grey"
          v-if="itemQuote.estimatedPrice > 0"
          v-show="!editMode.estimatedPrice.isEditing"
          @click.right.stop.prevent="enterEditMode('estimatedPrice')">
          <small>EST:</small> <strong>{{ itemQuote.estimatedPrice | CurrencyBR }}</strong>
        </span>
        <div class="edit-fieldset edit-specs" v-if="editMode.estimatedPrice.isEditing">
          <span class="text-edit--title">Estimado</span>
          <input
            class="textbox-edit textbox-input"
            v-model="editMode.estimatedPrice.text"
            v-shortkey="{ confirmEdit: ['enter'], cancelEdit: ['esc'] }" @shortkey="editAction"
            v-click-outside="closeEditMode">
        </div>

        <span class="badge-small badge-grey" v-if="itemQuote.estimatedPrice > 0"><small>TOTAL:</small> <strong>{{ itemQuote.estimatedPrice * itemQuote.quantity | CurrencyBR }}</strong></span>
      </div>
    </div>

    <right-side-panel ref="rspMessage" title="Revisão" :padding="false">
      <quote-item-message />
    </right-side-panel>
  </section>
</template>

<script>
import { CurrencyBR, DecimalNumber } from '@/components/primitives/helpers/filters'
import { IconLockGliph } from '@/components/primitives/icons'
import { mapGetters } from 'vuex'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
import { QuoteItemMessage } from '../../right-panel'

export default {
  name: 'ItemDetail',
  components: {
    RightSidePanel,
    QuoteItemMessage,
    IconLockGliph
  },
  data () {
    return {
      itemQuote: {
        _id: null,
        lot: '',
        number: '',
        unity: '',
        quantity: '',
        factor: '',
        estimatedPrice: '',
        description: ''
      },
      editMode: {
        description: {
          isEditing: false,
          text: null
        },
        quantity: {
          isEditing: false,
          text: null
        },
        estimatedPrice: {
          isEditing: false,
          text: null
        },
        factor: {
          isEditing: false,
          text: null
        },
        unity: {
          isEditing: false,
          text: null
        }
      }
    }
  },
  filters: {
    CurrencyBR,
    DecimalNumber
  },
  computed: {
    ...mapGetters({
      getSelectedDetailItem: 'ItemAssociation/GET_ITEM_SELECTED_DETAILS',
      itemHaveRevision: 'ItemAssociation/HAVE_REVISION'
    }),
    revisionStatus () {
      return this.itemHaveRevision ? 'LER REVISÃO' : 'CRIAR REVISÃO'
    },
    wordSeparated () {
      return this.itemQuote.description.split(' ')
    }
  },
  watch: {
    getSelectedDetailItem (pValue) {
      if (pValue) this.itemQuote = pValue
    }
  },
  methods: {
    buttonMessage () {
      this.$nextTick(() => {
        this.$refs.rspMessage.showPanel()
      })
    },
    enterEditMode (editField) {
      this.closeEditMode()
      this.editMode[editField].text = this.itemQuote[editField]
      this.editMode[editField].isEditing = true
    },
    editAction ({ srcKey }) {
      switch (srcKey) {
        case 'confirmEdit':
          this.confirmEdit()
          break
        case 'cancelEdit':
          this.closeEditMode()
          break
      }
    },
    async confirmEdit () {
      try {
        const result = await this.$store.dispatch('ItemAssociation/UPDATE_ITEM_DATA', {
          itemId: this.itemQuote._id,
          ...this.editMode
        })
        this.$store.commit('ItemAssociation/UPDATE_EDITED_ITEM', { itemId: result._id, infoData: { ...result.itemInfo } })
        this.$toasted.success('Informação editada com sucesso')

        this.closeEditMode()
      } catch (e) {
        this.$toasted.error('Não foi possível editar esse item')
      }
      this.closeEditMode()
    },
    closeEditMode () {
      this.editMode.description.isEditing = false
      this.editMode.description.text = null
      this.editMode.quantity.isEditing = false
      this.editMode.quantity.text = null
      this.editMode.estimatedPrice.isEditing = false
      this.editMode.estimatedPrice.text = null
      this.editMode.factor.isEditing = false
      this.editMode.factor.text = null
      this.editMode.unity.isEditing = false
      this.editMode.unity.text = null
    },
    selectWord (pWord) {
      const word = pWord.replace(/[^a-zA-ZÀ-ú0-9]/gi, ' ')
      const wordNormalized = word.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      this.$store.commit('ItemAssociation/SET_SEARCH_TIP', wordNormalized)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-association/components/top-bar/item-detail/ItemDetail.vue